module.exports = __webpack_public_path__ + "media/images/icons/repost_green-d5a6ce460193330c2876c3d121b474a0.svg";